import { RenderShop } from './RenderShop'

interface Props {
  name: string
  link: string
}
export const Shop: React.FC<Props> = ({ name, link }) => {
  return (
    <a href={link} target="_blank" rel="noreferrer">
      <RenderShop name={name} />
    </a>
  )
}
